import i18n from 'i18next';
import Backend from 'i18next-http-backend';
// eslint-disable-next-line max-len
// import LanguageDetector from 'i18next-browser-languagedetector'; // TODO: Add language detector back when adding french translation files
import { initReactI18next } from 'react-i18next';
import { routesENCA } from './routes';
import { TRANSLATION_FILE_VERSION } from './utils/translationVersion';

// eslint-disable-next-line quotes
const isProduction = process.env.REACT_APP_NODE_ENV === "'production'";
// eslint-disable-next-line quotes
const isStaging = process.env.REACT_APP_NODE_ENV === "'staging'";

i18n
  .use(Backend)
  // .use(LanguageDetector) // TODO: Add language detector back when adding french translation files
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    // whitelist: ['en-CA', 'fr-CA'],// TODO: Add fr-CA to whitelist languages back when adding french translation files
    whitelist: ['en-CA'],
    fallbackLng: 'en-CA',
    debug: false,
    load: 'currentOnly', // Load only the current language translation files
    backend: {
      loadPath:
        isStaging || isProduction
          ? `/locales/{{lng}}/{{ns}}-${TRANSLATION_FILE_VERSION}.json`
          : `/locales/{{lng}}/{{ns}}.json`
    },
    interpolation: {
      escapeValue: false // not needed for react!!
    },
    // react i18next special options (optional)
    // override if needed - omit if ok with defaults
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false
    }
  });

/**
 * Adding the routes resource bundle directly to have them ready whenever the app is loaded
 */
i18n.addResourceBundle('en-CA', 'routes', routesENCA);

export default i18n;
